export default "__VITE_ASSET__8xMXsqQI__"